import { render, staticRenderFns } from "./CoverBlock.vue?vue&type=template&id=fd86171c&scoped=true&"
import script from "./CoverBlock.vue?vue&type=script&lang=js&"
export * from "./CoverBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoverBlock.vue?vue&type=style&index=0&id=fd86171c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd86171c",
  null
  
)

export default component.exports